<template>
	<div>
		<div
			:class="{ open: isOpen }"
			class="section-item-container width-100 display-flex flex-row flex-align-center flex-justify-space-between"
		>
			<div class="display-flex flex-row flex-align-center">
				<div class="icon-container flex-centerize">
					<SIcon width="22" height="22" :name="sectionDetails.iconName" />
				</div>
				<div class="section-title">{{ sectionDetails.title }}</div>
			</div>
			<div class="display-flex flex-row flex-align-center">
				<template v-if="isCompleted">
					<SIcon class="mr-2" name="on-boarding-complete" width="25" height="25" />
					<div class="complete-text">Completed</div>
				</template>
				<template v-else>
					<div class="remaining-text" :class="{ bold: isOpen }">{{ numberOfStepsText }},&nbsp;</div>
					<div class="remaining-text">{{ numberOfMinutesText }}</div>
				</template>
			</div>
		</div>
		<div class="progress-container" v-if="isOpen" :style="`width: ${progressPercentage}%; transition: 0.8s`" />
	</div>
</template>

<script>
import { pluralize } from '@/utils/language-service';
export default {
	name: 'OnBoardingSectionHeader',
	props: {
		isOpen: { type: Boolean },
		numOfSteps: { type: Number },
		sectionDetails: { type: Object },
		numOfCompletedSteps: { type: Number },
		remainingNumOfMinutes: { type: Number },
		totalNumOfMinutesToComplete: { type: Number },
	},
	components: {},
	computed: {
		isCompleted() {
			return this.numOfSteps === this.numOfCompletedSteps;
		},
		numberOfStepsText() {
			if (this.numOfCompletedSteps) {
				return `${pluralize('step', this.numOfSteps - this.numOfCompletedSteps, true)} left`;
			} else {
				return `${pluralize('step', this.numOfSteps, true)}`;
			}
		},
		numberOfMinutesText() {
			return `${pluralize('minute', this.remainingNumOfMinutes, true)}`;
		},
		progressPercentage() {
			if (this.totalNumOfMinutesToComplete !== this.remainingNumOfMinutes > 0) {
				return ((this.totalNumOfMinutesToComplete - this.remainingNumOfMinutes) / this.totalNumOfMinutesToComplete) * 100;
			} else {
				return 0;
			}
		},
	},
	methods: {},
	mounted() {},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
$transition-time: 0.3s;
.section-item-container {
	padding: 25px;
	min-height: 90px;
	border-radius: 10px;
	letter-spacing: 0px;
	background: var(--white);
	transition: $transition-time;
	color: var(--primary-font-color);
	border: 1px solid var(--border-color);
	&.open {
		transition: $transition-time;
		border-radius: 10px 10px 0 0;
	}
	&:hover {
		cursor: pointer;
		background: #eeeffa;
		transition: $transition-time;
		box-shadow: 0px 3px 6px var(--shadow-color);
	}
	&:active {
		filter: brightness(0.9);
		transition: $transition-time;
	}
}

.icon-container {
	width: 40px;
	height: 40px;
	margin-right: 10px;
	border-radius: 10px;

	background: #f6f8fa;
	border: 1px solid #e4e7ed;
}
.section-title {
	font-size: 16px;
	font-weight: bold;
}
.remaining-text {
	font-size: 16px;
	&.bold {
		font-weight: bold;
	}
}
.complete-text {
	font-size: 16px;
	color: #4bcca2;
	font-weight: normal;
}
.progress-container {
	width: 0px;
	height: 2px;
	margin-top: -2px;
	transition: 0.8s;
	background: #4bcca2;
}
</style>
